module.exports = __webpack_public_path__ + "static/media/BBCReithSans_W_Rg.db986b48.woff";